import React from "react";
import { DialogBox, DialogBoxFooterType } from "~/core";
import { messages } from "../../i18n-messages";
import { intlShape, injectIntl } from "@ai360/core/intl";
import "./jd-match-found-modal.css";

interface IJdMatchFoundModalProps {
    intl: intlShape;
    isOpen: boolean;
    partialJdMatch: boolean;
    jdClientExists: boolean;
    overlappedOrMatchedJdOpsCenterClientName: string;
    overlappedOrMatchedJdOpsCenterFarmName: string;
    overlappedOrMatchedJdOpsCenterFieldName: string;
    systemName: string;

    onClose: () => void;
    onProceedWithJdBoundaryMatch: (isLink: boolean) => void;
}

export const JdMatchFoundModal_ = (props: IJdMatchFoundModalProps) => {
    return (
        <DialogBox
            draggable
            footerType={DialogBoxFooterType.MULTI_ACTION_CANCEL}
            className="jd-match"
            isOpen={props.isOpen}
            multiActionList={[
                {
                    action: "Link",
                    onAction: () => props.onProceedWithJdBoundaryMatch(true),
                },
                {
                    action: "New",
                    onAction: () => props.onProceedWithJdBoundaryMatch(false),
                },
            ]}
            onClose={props.onClose}
            title={props.intl.formatMessage(messages.jdMatchFound, {
                partial: props.partialJdMatch ? "Partial " : "",
            })}
            testId="jd-match-found-modal"
        >
            <div className="jd-match-message">
                <div className="jd-match-line">
                    {props.intl.formatMessage(messages.jdMatchMessage, {
                        overlapsOrMatches: props.partialJdMatch ? "overlaps" : "matches",
                    })}
                </div>
                <div className="jd-match-details">
                    {props.intl.formatMessage(messages.jdMatchDetailsClient, {
                        clientName: props.overlappedOrMatchedJdOpsCenterClientName,
                    })}
                </div>
                <div className="jd-match-details">
                    {props.intl.formatMessage(messages.jdMatchDetailsFarm, {
                        farmName: props.overlappedOrMatchedJdOpsCenterFarmName,
                    })}
                </div>
                <div className="jd-match-details">
                    {props.intl.formatMessage(messages.jdMatchDetailsField, {
                        fieldName: props.overlappedOrMatchedJdOpsCenterFieldName,
                    })}
                </div>
                <div className="jd-match-prompt-line">
                    {props.intl.formatMessage(messages.promptAddMatchingFieldToJdOpsMsg, {
                        clientAnd: props.jdClientExists ? "" : "Client and ",
                        systemName: props.systemName,
                    })}
                </div>
            </div>
        </DialogBox>
    );
};

export const JdMatchFoundModal = injectIntl(JdMatchFoundModal_);
